module.exports = __webpack_public_path__ + "img/banner-support.c63f4fbd.jpg";